import { render } from "./BaseBallFinlandLogo.vue?vue&type=template&id=4268fc24"
const script = {}

import "./BaseBallFinlandLogo.vue?vue&type=style&index=0&id=4268fc24&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__